module.exports = __webpack_public_path__ + "img/essilor-black.dc752c6a.svg";